var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgClockDollar(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M16 4c6.617 0 12 5.383 12 12 0 1.431-.25 2.832-.744 4.166a.4.4 0 01-.75-.278c.46-1.244.694-2.552.694-3.888 0-6.176-5.024-11.2-11.2-11.2C9.824 4.8 4.8 9.824 4.8 16c0 6.176 5.024 11.2 11.2 11.2a11.18 11.18 0 003.888-.694.399.399 0 11.278.75A11.963 11.963 0 0116 28C9.383 28 4 22.617 4 16S9.383 4 16 4zm7.6 15.6a.4.4 0 01.4.4v.44c.912.186 1.6.994 1.6 1.96a.4.4 0 11-.8 0 1.2 1.2 0 00-.8-1.126v2.175l.892.694c.31.241.512.604.553.995a1.38 1.38 0 01-.317 1.042 1.997 1.997 0 01-1.128.667v.353a.4.4 0 11-.8 0v-.352a2.004 2.004 0 01-1.6-1.96.4.4 0 11.8 0c0 .522.336.962.8 1.127V23.84l-.892-.693a1.46 1.46 0 01-.553-.997 1.37 1.37 0 01.318-1.04c.293-.348.69-.58 1.127-.668V20a.4.4 0 01.4-.4zm.4 4.862v1.551c.198-.07.378-.185.517-.35a.583.583 0 00.132-.442.657.657 0 00-.249-.447l-.4-.312zm-8-.51a.4.4 0 01.4.4v.4a.4.4 0 11-.8 0v-.4a.4.4 0 01.4-.4zm7.2-2.676c-.198.07-.378.185-.517.35a.584.584 0 00-.132.441c.018.176.109.34.249.448l.4.311zm-13.422.332a.4.4 0 11.565.566l-.283.283a.399.399 0 01-.565 0 .4.4 0 010-.566zM16 9.952a.4.4 0 01.4.4v4.056c.688.18 1.2.8 1.2 1.544 0 .882-.718 1.6-1.6 1.6a1.598 1.598 0 01-1.543-1.2H11.6a.4.4 0 110-.8h2.857c.145-.56.583-.998 1.143-1.144v-4.056a.4.4 0 01.4-.4zm0 5.2a.8.8 0 10.002 1.601.8.8 0 00-.002-1.601zm8.8.4a.4.4 0 110 .8h-.4a.4.4 0 110-.8zm-17.2 0a.4.4 0 110 .8h-.4a.4.4 0 110-.8zm14.34-6.106a.4.4 0 11.565.566l-.283.282a.399.399 0 01-.565 0 .4.4 0 010-.565zm-12.445 0a.4.4 0 01.565 0l.283.283a.4.4 0 11-.565.565l-.283-.282a.4.4 0 010-.566zM16 6.752a.4.4 0 01.4.4v.4a.4.4 0 11-.8 0v-.4a.4.4 0 01.4-.4z"
  }));
}

export default SvgClockDollar;